/** @format */
import { camelCase, camelCaseTransformMerge, snakeCase } from 'change-case';

export function toSnakeCase(key: string): string {
    return snakeCase(key, {
        transform: (input: string) => {
            const firstChar = input.charAt(0);
            const otherChars = input.substr(1).toLowerCase();
            return (
                '' +
                firstChar.toLowerCase() +
                otherChars.replace(/(\d+)$/, '_$1')
            );
        },
    });
}

export function toCamelCase<T = string>(key: string): T {
    return camelCase(key, {
        transform: camelCaseTransformMerge,
    }) as T;
}

/**
 * Recursively convert the key names of an object.
 *
 * @param object the object to convert
 * @param convert the conversion function
 */
export function convertKeyNames(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
    object: any,
    convert: (name: string) => string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Legacy code: do not use as an example.
): any {
    if (object == null || typeof object !== 'object') {
        return object;
    }

    if (Array.isArray(object)) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
        return object.map((value) => convertKeyNames(value, convert));
        // eslint-disable-next-line no-else-return -- Legacy code: do not use as an example.
    } else {
        const converted = {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
        Object.keys(object).forEach((key) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
            if (Object.keys(object).includes(key)) {
                // @ts-ignore - Element implicitly has an any type - Touch and Change
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- Legacy code: do not use as an example.
                converted[convert(key)] = convertKeyNames(object[key], convert);
            }
        });
        return converted;
    }
}
